import { GroupHistoryMode, GroupsMode } from '@go-client/pages/GroupsHome';
import React from 'react';
import { FormGenericContainer } from '../FormGenericContainer';
import { BubbleBadge, BubbleButton } from '@go-client/components/BubbleUI';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { hashStringToColor } from '@go-shared/lib/utils';
import { GroupMessage } from '@go-client/components';
import { useUserInfo } from '@go-client/context/UserInfoContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface GroupPartyHistoryProps {
  onClose?: () => void;
  mode: Extract<GroupsMode, GroupHistoryMode>;
}

export default function GroupPartyHistory({ onClose, mode }: GroupPartyHistoryProps) {
  const { activeProperty } = useActiveProperty();
  const { user } = useUserInfo();
  const comments = mode.group.party.comments;
  return (
    <FormGenericContainer footer={() => {}}>
      <div className="flex items-start mb-5">
        <div>
          <div className="flex items-center">
            <h1 className="text-lg text-slate-dark font-semibold">
              <span>Group Party History</span>
            </h1>
            <BubbleBadge color={hashStringToColor(activeProperty.name)} className="ml-3">
              {activeProperty.name}
            </BubbleBadge>
          </div>
          <h2 className="text-2xl text-navy">1. View History</h2>
        </div>
        <div className="ml-auto" />
        <BubbleButton variant="navy" inverse onClick={onClose} icon="xmark-large" iconSize="xl" />
      </div>
      <div className="bg-grey-lightest shadow-md flex flex-col">
        <div className="flex items-center gap-2 px-3 py-3 border-l-4 border-navy">
          <FontAwesomeIcon icon="clock" className="text-navy" />
          <h1 className="font-semibold text-sm text-navy">History</h1>
        </div>
        <div className="p-2 flex flex-col gap-2">
          {comments.length === 0 && <span className="text-smoke italic">No history yet.</span>}
          {comments
            .filter(c => c.message)
            .map((c, i) => (
              <GroupMessage
                key={i}
                comment={c}
                position={c.user?._id === user._id ? 'right' : 'left'}
                dark={c.user?._id === user._id}
              />
            ))}
        </div>
      </div>
    </FormGenericContainer>
  );
}
